// Shared helpers, styles and constants for Generative Design components.
import { card, btn, btnGhost, label, inputStyle } from "../roads/_roadsCommon";

export { card, btn, btnGhost, label, inputStyle };

export function initialCfg(domain) {
  const base = {
    num_alternatives: 7,
    budget_min_INR_cr: 50,
    budget_max_INR_cr: 200,
    max_construction_months: 24,
    objective_weights: {
      capital_cost: 0.30, construction_time: 0.20,
      energy_efficiency: 0.15, safety_margin: 0.10,
      green_score: 0.10, code_compliance: 0.05,
      operating_cost: 0.10,
    },
  };
  if (domain === "process_plant")
    return { ...base, feed_rate_MTPD: 100 };
  if (domain === "infrastructure")
    return { ...base, road_type: "NH", design_speed_kmh: 100,
                length_km: 20, lanes: 4, terrain: "rolling",
                river_crossings: [{ chainage_km: 8 }] };
  return { ...base, plot_area_m2: 5000, fsi_allowed: 2.5,
              max_floors: 20, building_type: "residential" };
}

export const Row = ({ k, v, fk, update }) => (
  <div style={{ display: "flex", justifyContent: "space-between",
                    alignItems: "center", fontSize: 11 }}>
    <span style={{ color: "var(--pf-muted)" }}>{k}</span>
    <input style={{ ...inputStyle, width: 120, fontSize: 11 }} value={v}
        onChange={(e) => update(fk, parseFloat(e.target.value) || 0)} />
  </div>
);

export const SelectRow = ({ k, v, fk, update, opts }) => (
  <div style={{ display: "flex", justifyContent: "space-between",
                    alignItems: "center", fontSize: 11 }}>
    <span style={{ color: "var(--pf-muted)" }}>{k}</span>
    <select style={{ ...inputStyle, width: 120, fontSize: 11 }} value={v}
        onChange={(e) => update(fk, e.target.value)}>
      {opts.map(o => <option key={o} value={o}>{o}</option>)}
    </select>
  </div>
);

export const Card = ({ l, v, color }) => (
  <div style={{ ...card, padding: 12, textAlign: "center" }}>
    <div style={{ ...label, fontSize: 9 }}>{l}</div>
    <div style={{ fontSize: 22, fontWeight: 700, color: color || "var(--pf-text)",
                      marginTop: 4 }}>{v ?? "—"}</div>
  </div>
);

export const DOMAIN_LABELS = {
  process_plant: { label: "Process Plant", desc: "Refining / Petrochem / Specialty" },
};
